import type { Ref } from 'react'
import type { TextInput } from 'react-native'
import type { TextInput as RNGHInput } from 'react-native-gesture-handler'

/**
 * BottomSheetTextInput (@gorhom/bottom-sheet) expects a Ref of the
 * react-native-gesture-handler TextInput, which is structurally the same as the
 * react-native TextInput but not assignable in TS. Bridge the ref safely.
 */
export const asBottomSheetRef = (ref: Ref<TextInput> | undefined): Ref<RNGHInput> => {
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- bottom-sheet ref typing: RNGHInput is structurally TextInput
  return ref as Ref<RNGHInput>
}
